import BellIcon from '../assets/logo/BellIcon';
import IllustrationExplainer from '../components-library/IllustrationExplainer';
import { SCREENS } from '../services/exports/Constants';
import { useTranslation } from 'react-i18next';
import WindowResource from '../services/resources/WindowResource';

export default function ErrorScreen() {
  const { t } = useTranslation(null, { keyPrefix: 'Pages:ErrorScreen' });

  const navigateHome = (): void => WindowResource.setHref(SCREENS.HOME_SCREEN);

  return (
    <main className={container} data-test="error-screen">
      <IllustrationExplainer
        illustration={<BellIcon className="h-20 w-20" />}
        title={t('header')}
        description={t('text')}
      />
      <div className={buttonContainer}>
        <button type="button" onClick={navigateHome} className={button}>
          {t('button')}
        </button>
      </div>
    </main>
  );
}

const container = 'fixed inset-0 flex flex-col h-full w-full justify-center items-center lg:w-1/2 w-full mx-auto px-md';

const buttonContainer = 'lg:mt-xl mt-lg';

const button =
  'inline-flex items-center justify-center rounded-[9999px] bg-black text-white text-sm font-semibold px-xl py-sm hover:opacity-90 transition-opacity';
